module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "list-item"
  }, [_c('div', [_c('div', {
    staticClass: "flex-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.item.createTimes))]), _vm._v(" "), _c('p', {
    staticClass: "textnum"
  }, [_vm._v(_vm._s(_vm.item.classId))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": ("/signature/" + (_vm.item.id) + "/" + (_vm.item.signStatus) + "/false")
    }
  }, [(_vm.item.signStatus == '1') ? [_c('span', {
    on: {
      "click": function($event) {
        return _vm.look(_vm.item.id, _vm.item.signStatus, _vm.item.status, _vm.item.createTimes)
      }
    }
  }, [_vm._v("查看>")])] : [_c('span', {
    staticStyle: {
      "color": "#13ce66"
    },
    on: {
      "click": function($event) {
        return _vm.look(_vm.item.id, _vm.item.signStatus, _vm.item.status, _vm.item.createTimes)
      }
    }
  }, [_vm._v("签字>")])]], 2)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-748c59c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsItem.vue
// module id = 786
// module chunks = 1